import { findArray } from 'helpers/utils'
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useGetEventUnits } from 'helpers/commonCodes';

export const EVENTUNIT_SIZE = {
    "NORMAL": "N",
    "LONG": "L",
    "SHORT": "S",
};

export function useEventUnit() {
    //const { mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const params = useUrlFriendlyToParameters()
    let paramsURL = { ...params }
    const data = useGetEventUnits(paramsURL);
    return function (code, size) {
        const filter = {
            code: [code]
        }
        const element = findArray(data?.eventUnits, filter)
        const description = element ? element?.description : "";
        const shortDescription = element ? element?.shortDescription : "";
        const longDescription = element ? element?.longDescription : "";
        let resp = '';
        switch (size) {
            case EVENTUNIT_SIZE.LONG:
                resp = longDescription;
                break;
            case EVENTUNIT_SIZE.SHORT:
                resp = shortDescription;
                break;
            default:
                resp = description;
        }

        return (resp);
    }
}